import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Layout, Button, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ChatView } from '../components/chat/ChatView';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store';
import { Project } from '../types/project';
import { ProjectStage } from '../constants/stages';
import { fetchProjects } from '../store/projectSlice';
import { socketService } from '../services/socket';

const { Content } = Layout;

const Container = styled(Layout)`
  height: 100vh;
`;

const MainContent = styled(Content)`
  height: 100%;
  overflow: auto;
  background: #fff;
  position: relative;
`;

const BackButton = styled(Button)`
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 10;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const ChatPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectId, stage } = useParams<{ projectId: string; stage: string }>();
  const projects = useSelector((state: RootState) => state.project.projects);
  const loading = useSelector((state: RootState) => state.project.loading);
  const currentProject = projects.find((p: Project) => p.id === projectId) || null;

  useEffect(() => {
    // 如果projects为空，加载项目数据
    if (projects.length === 0) {
      dispatch(fetchProjects() as any);
    }

    // 组件卸载时清理
    return () => {
      socketService.disconnect();
    };
  }, [dispatch, projects.length]);

  const handleBack = () => {
    // 先断开 WebSocket 连接
    socketService.disconnect();
    // 然后再导航
    navigate('/app');
  };

  if (loading) {
    return (
      <Container>
        <MainContent>
          <LoadingContainer>
            <Spin size="large" tip="加载中..." />
          </LoadingContainer>
        </MainContent>
      </Container>
    );
  }

  return (
    <Container>
      <MainContent>
        <BackButton 
          icon={<ArrowLeftOutlined />} 
          onClick={handleBack}
        >
          返回
        </BackButton>
        {currentProject && stage && (
          <ChatView
            currentProject={currentProject}
            selectedStage={Number(stage) as ProjectStage}
          />
        )}
      </MainContent>
    </Container>
  );
};

export default ChatPage; 